// extracted by mini-css-extract-plugin
export default {"Modal":"HireConfirmModal_Modal__5f29z","Overlay":"HireConfirmModal_Overlay__3e52+"};